import React from 'react';
import ArticleWrapper from '../../components/ArticleWrapper';

const GMKMercury = () => (
  <ArticleWrapper articleId="gmk_mercury">
    <div className="min-h-screen bg-[#111112] flex flex-col w-full">
      <div className="prose prose-invert mx-auto p-6">
        <h1>GMK Mercury</h1>
        {/* Add your GMK Mercury article content here */}
        <p>This is a placeholder article for the GMK Mercury keycap set. More content coming soon.</p>
      </div>
    </div>
  </ArticleWrapper>
);

export default GMKMercury;
